require("-!style-loader!css-loader!sass-loader!/Users/squitty/gowatchit/apps/gwi-masons/gwi-brick/node_modules/font-awesome-sass-loader/font-awesome-sass-styles.loader.js!/Users/squitty/gowatchit/apps/gwi-masons/gwi-brick/font-awesome-sass.config.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass-loader/index.loader.js!./font-awesome-sass.config.js
// module id = 1
// module chunks = 0